import React, { useEffect, useState } from "react";
import ActivityReportsFilter from "./ActivityReportsFilter";
import { Table } from "antd";
import { Api_Url } from "../../../config/config";
import axios from "axios";
import { Link } from "react-router-dom";

function ActivityReportsPage() {

    const [allData, setAllData] = useState([]);

    const handleFilter = (data) => {
      setAllData(data);
    };
  
    useEffect(() => {
      allTeamReportsFetchFunction();
    }, []);
  
    const allTeamReportsFetchFunction = async () => {
      try {
        const response = await axios.get(`${Api_Url}`, {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        });
        console.log(response.data.data);
        setAllData(response?.data?.data);
      } catch (error) {
        console.log(error);
      }
    };


    
    const columns = [
        {
          title: "Name",
          dataIndex: "name",
          render: (text, record) => (
            <span className="table-avatar">
              <Link className="avatar">
                <img alt="" src={record.profileImageUrl} />
              </Link>
              <Link>
                {record?.firstName} {record?.lastName} ({record?.code})
              </Link>
            </span>
          ),
        },
        {
          title: "Email",
          dataIndex: "email",
        },
        {
          title: "Mobile Number",
          dataIndex: "mobile",
        },
        {
          title: "Designation Name",
          dataIndex: "designationName",
        },
        {
          title: "Branch Name",
          dataIndex: "branchName",
        },
        {
          title: "Department Name",
          dataIndex: "departmentName",
        },
      ];

  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
        <div className="row mb-4">
              <div className="col-12 d-flex align-items-center justify-content-between">
                <h3 className="mb-0">Activity Reports</h3>
              </div>
            </div>
            <ActivityReportsFilter parentFunctionLeads={handleFilter}/>

            <div className="row mt-4">
              <div className="col-12 mx-auto">
                <Table
                  className="table-striped"
                  style={{ overflowX: "auto" }}
                  columns={columns}
                  dataSource={allData}
                  rowKey={(record) => record.id}
                />
              </div>
            </div>
        </div>
      </div>
    </>
  );
}

export default ActivityReportsPage;
